import { makeStyles, Theme } from '@material-ui/core/styles';

// import { FONTS } from 'content-creator/views/theme';

const SIZE = 30;
const COLOR_BG = '#E6EAF6';
const COLOR_LOW = '#D43434';
const COLOR_MEDIUM = '#FFCA00';
const COLOR_HIGH = '#3AB409';
const COLOR_TEXT = '#2F393E';

const pickColor = (scoreLevel: string) => {
  if (scoreLevel === 'low') {
    return COLOR_LOW;
  }
  if (scoreLevel === 'medium') {
    return COLOR_MEDIUM;
  }
  return COLOR_HIGH;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default makeStyles<Theme, { classes: any; scoreLevel: string }>(
  // @ts-ignore
  (theme) => ({
    root: {
      position: 'relative',
      width: SIZE,
      height: SIZE,

      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    Loader: {
      width: '30px !important',
      height: '30px !important'
    },
    ScoreContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    circleBg_root: {
      position: 'absolute'
    },
    circleBg_circle: {
      stroke: COLOR_BG,
      strokeWidth: '3px'
    },
    circle_root: {
      position: 'absolute',
      transform: 'rotate(-90deg) scale(1, -1) !important'
    },
    circle_circle: {
      stroke: ({ scoreLevel }: { scoreLevel: string }) => pickColor(scoreLevel),
      strokeWidth: '3px'
    },
    score: {
      fontFamily: 'Source Sans Pro, Helvetica, Arial, sans-serif',
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightMedium,
      color: COLOR_TEXT,
      marginBottom: '-2px'
    }
  }),
  { name: 'VariationScore' }
);
